export enum LeadSource {
  PETRIE = 'Petrie',
  YARDI = 'Yardi',
}
